// Full list of languages Speechmatics supports for the realtime API.
// Must stay in sync with phantomCodeDesktopapp/src/lib/speechmaticsLanguages.ts

export interface SpeechmaticsLanguage {
  code: string
  label: string
}

export const SPEECHMATICS_LANGUAGES: SpeechmaticsLanguage[] = [
  { code: "en", label: "English" },
  { code: "auto", label: "Auto-detect" },
  { code: "ar", label: "Arabic" },
  { code: "ar_en", label: "Arabic + English (bilingual)" },
  { code: "ba", label: "Bashkir" },
  { code: "eu", label: "Basque" },
  { code: "be", label: "Belarusian" },
  { code: "bn", label: "Bengali" },
  { code: "bg", label: "Bulgarian" },
  { code: "yue", label: "Cantonese" },
  { code: "ca", label: "Catalan" },
  { code: "hr", label: "Croatian" },
  { code: "cs", label: "Czech" },
  { code: "da", label: "Danish" },
  { code: "nl", label: "Dutch" },
  { code: "eo", label: "Esperanto" },
  { code: "et", label: "Estonian" },
  { code: "fi", label: "Finnish" },
  { code: "fr", label: "French" },
  { code: "gl", label: "Galician" },
  { code: "de", label: "German" },
  { code: "el", label: "Greek" },
  { code: "he", label: "Hebrew" },
  { code: "hi", label: "Hindi" },
  { code: "hu", label: "Hungarian" },
  { code: "id", label: "Indonesian" },
  { code: "ia", label: "Interlingua" },
  { code: "ga", label: "Irish" },
  { code: "it", label: "Italian" },
  { code: "ja", label: "Japanese" },
  { code: "ko", label: "Korean" },
  { code: "lv", label: "Latvian" },
  { code: "lt", label: "Lithuanian" },
  { code: "ms", label: "Malay" },
  { code: "en_ms", label: "Malay + English (bilingual)" },
  { code: "mt", label: "Maltese" },
  { code: "cmn", label: "Mandarin" },
  { code: "cmn_en", label: "Mandarin + English (bilingual)" },
  { code: "cmn_en_ms_ta", label: "Mandarin / Malay / Tamil / English (multi)" },
  { code: "mr", label: "Marathi" },
  { code: "mn", label: "Mongolian" },
  { code: "no", label: "Norwegian" },
  { code: "fa", label: "Persian" },
  { code: "pl", label: "Polish" },
  { code: "pt", label: "Portuguese" },
  { code: "ro", label: "Romanian" },
  { code: "ru", label: "Russian" },
  { code: "sk", label: "Slovakian" },
  { code: "sl", label: "Slovenian" },
  { code: "es", label: "Spanish" },
  { code: "sw", label: "Swahili" },
  { code: "sv", label: "Swedish" },
  { code: "tl", label: "Tagalog (Filipino) + English (bilingual)" },
  { code: "ta", label: "Tamil" },
  { code: "en_ta", label: "Tamil + English (bilingual)" },
  { code: "th", label: "Thai" },
  { code: "tr", label: "Turkish" },
  { code: "uk", label: "Ukrainian" },
  { code: "ur", label: "Urdu" },
  { code: "ug", label: "Uyghur" },
  { code: "vi", label: "Vietnamese" },
  { code: "cy", label: "Welsh" },
]

export const DEFAULT_SPEECHMATICS_LANGUAGE = "en"

export function isSupportedSpeechmaticsLanguage(code: string): boolean {
  return SPEECHMATICS_LANGUAGES.some((l) => l.code === code)
}

export function getLanguageLabel(code: string): string {
  return SPEECHMATICS_LANGUAGES.find((l) => l.code === code)?.label ?? code
}
